import { Box, Dialog, IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { APP_VERSION } from "config";

const DialogCustom = ({ open = false, handleClose = () => {}, children, title = "" }) => {
  const { t } = useTranslation();
  const label = title || `${t("software version")} ${APP_VERSION}`;
  const isXsOnly = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: { sm: "20px" },
          margin: { sm: "12px" },
          width: { sm: "760px", lg: "912px" },
        },
      }}
      sx={{
        boxShadow: "0px -8px 16px 0px #00000040 inset",
      }}
      fullScreen={isXsOnly}
      maxWidth={false}
    >
      <Box sx={{ px: "24px", pt: "24px", pb: "48px" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={600} color="primary.main">
            {label}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Box sx={{ mt: "24px"}}>
          {children}
        </Box>
      </Box>
    </Dialog>
  );
};

export default DialogCustom;
